import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import {DownloadSimple, Eye, Prohibit, FilePdf} from "@phosphor-icons/react";
import {TableAction} from "@beeldit/core/enums/TableAction.enum";
import {Order} from "@beeldit/ecommerce/orders/models/Order";
import {SuperOrder} from "@beeldit/ecommerce/super-orders/models/SuperOrder";

const tableConfig: FinalTableConfig = {
      index: null,
      actions: [
          {
              name: TableAction.EXPORT,
              label: "export",
              showLabel: true,
              allowed: true,
              show: true,
              action: null,
              variant: 'secondary',
              icon: <DownloadSimple size={20} />,
          }
      ],
      rowActions: [
        {
          name: RowAction.DETAILS,
          label: 'edit',
          icon: <Eye size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
              console.log('edit', element);
          }
        },
        {
          name: "cancel",
          label: 'cancel_super_order',
          icon: <Prohibit size={20} />,
          allowed: true,
          show: (element: any, user: any) => {
              return element.status !== SuperOrder.CANCELLED
          },
          action: (element: any) => {
              console.log('edit', element);
          }
        },
        {
          name: "request-invoice",
          label: 'request_invoice',
          icon: <FilePdf size={20} />,
          allowed: true,
          data: 0, // Esto es para que devuelve el modelo completo
          show: (element: any, user: any) => {
              return element.status === SuperOrder.COMPLETED && !element.request_invoice
          },
          action: (element: any) => {
              console.log('edit', element);
          }
        },
      ],
      rowConfiguration: {
        class: (element: any) => {
          return null;
        }
      },
      columns: [
        {
          name: 'id',
          label: '#',
          key: 'id',
          type: 'number',
          show: true,
          sortable: true,
        },
        {
          name: 'customer',
          label: 'customer',
          key: 'customer.user',
          type: 'concat',
          fields: ['name', 'surnames'],
          show: true,
          sortable: false,
        },
        {
          name: 'reference',
          label: 'reference',
          key: 'reference',
          type: 'string',
          show: true,
          sortable: true,
        },
        {
          name: 'lower_order_status',
          label: 'lower_order_status',
          key: 'lower_order_status',
          type: 'translation',
          translation_prefix: "order_status",
          show: true,
          badge: true,
          badge_type: (lower_order_status: any) => {
              if (lower_order_status == Order.PENDING_STATUS) {
                  return 'warning'
              } else if (lower_order_status == Order.PAYED_STATUS) {
                  return 'success'
              } else if (lower_order_status == Order.IN_PREPARATION ||
                  lower_order_status == Order.MANAGING_SHIPMENT ||
                    lower_order_status == Order.IN_TRANSIT) {
                  return 'info'
              } else if (lower_order_status == Order.DELIVERED) {
                  return 'success'
              } else if (lower_order_status == Order.CANCELLED) {
                  return 'danger'
              }
          },
          sortable: false,
        },
        {
          name: 'created_at',
          label: 'created_at',
          key: 'created_at',
          type: 'datetime',
          show: true,
          sortable: true,
        },
        {
          name: 'total',
          label: 'total',
          key: 'total_prices.total',
          type: 'currency',
          currency: 'EUR',
          show: true,
          sortable: true,
        }
      ],
      pagination: {
        enabled: true,
        back: true
    }
}
const getConfig: any = (functions: any) => {
    const { detailsFunction, indexFunction, exportFunction, prepareCancelFunction, showModalRequestInvoice } = functions;
    tableConfig.actions[0].action = () => exportFunction();
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => detailsFunction(id);
    tableConfig.rowActions[1].action = (id: any) => prepareCancelFunction(id);
    tableConfig.rowActions[2].action = (element: any) => showModalRequestInvoice(element);
    return tableConfig;
}
export default getConfig;
